import React, { useState, useContext, useEffect } from 'react'
import { Col, Row, Form, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobileAlt, faTabletAlt, faGlobeAsia, faUserCircle, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { updateUser, viewUser, addUserRole, removeUserRole } from "../Network/User"
import { useHistory, useParams } from 'react-router-dom'
import { Loading, HeaderTitle } from '../Library'
import { listCompany } from '../Network/Company'
import { listDepartment, addUserToDepartment, removeFromDepartment } from '../Network/Department'
import { listRole } from '../Network/Role'
import MultiSelect from "react-multi-select-component";
import "./VisitorDetail.css"
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from "../Role/RoleContext"
import axios from 'axios'
import { wtc5214 ,visitor8082} from '../Network/Config'

function VisitorOrganizeCarCreate(props) {
    console.log(props.company);
    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.user
    const notifyCx = useContext(NotifyContext);
    const history = useHistory();
    const { securityId } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [loadingTitle, setLoadingTitle] = useState("Loading");

    const [securityVisitor, setSecurityVisitor] = useState([])
    const [carNumber, setCarNumber] = useState("");
    const [carType, setCarType] = useState("");
    const [carCompany, setCarCompany] = useState("");
    const [companyName, setCompanyName] = useState("")
    const [isError, setError] = useState(false);


    const [role, setRole] = useState([])

    useEffect(() => {
        setDocumentTitle("Create Security")
    }, [])


    const onSubmit = () =>{
        if( !carNumber ,!carType,!carCompany ){ 
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }
        setLoadingTitle(lang.updating)
        setLoading(true);
        updateSecurity(carNumber, carType, carCompany);
    }
    
    const updateSecurity = async (carNumber, carType, carCompany) =>{
        const formDataUpdate = new FormData();
        formDataUpdate.append('company_name', props.company);
        formDataUpdate.append('car_type', carType);
        formDataUpdate.append('company', carCompany);
        formDataUpdate.append('car_id', carNumber);
        const responseData = await axios.post(visitor8082+'/visitor/api/v1/addcar_idbyapp', formDataUpdate);
        setLoading(false)
        history.push("/visitor_organize_car")
    }

    return (
        <>
        { isLoading ? <Loading title={loadingTitle}/>: null }
        <div id="create-user">
            <HeaderTitle title={'เพิ่มทะเบียนรถ'} isShowBack backTo="/visitor_organize_car"/>
            <Row style={{width: "100%"}}>
                <Col className="content-container" md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault();
                        onSubmit();
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{'ทะเบียนรถ'}</Form.Label>
                            <Form.Control
                            placeholder="ทะเบียนรถ"
                            value={carNumber}
                            isInvalid={isError && !carNumber}
                            onChange={(e)=>setCarNumber(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{'ประเภทรถ'}</Form.Label>
                            <Form.Control 
                                as="select" 
                                value={carType} 
                                onChange={(e)=>setCarType(e.target.value)}
                                isInvalid={isError && !carType}
                            >
                                <option value={''} disabled >{'ประเภทรถ'}</option>
                                <option value={'รถพนักงาน'}>{'รถพนักงาน'}</option>
                                <option value={'รถขนขยะ'}>{'รถขนขยะ'}</option>
                                <option value={'รถ Owner/Consult'}>{'รถ Owner/Consult'}</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{'บริษัท'}</Form.Label>
                            <Form.Control
                            placeholder="บริษัท"
                            value={carCompany}
                            isInvalid={isError && !carCompany}
                            onChange={(e)=>setCarCompany(e.target.value)}
                            />
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Button type="submit" style={{marginTop: 30}}>{'บันทึกทะเบียนรถ'}</Button>
                        </Form.Group>
                        
                    </Form>
                </Col>
            </Row>
        </div>
        </>
    )
}

export default VisitorOrganizeCarCreate
